import { render, staticRenderFns } from "./CardSidebarTabActivity.vue?vue&type=template&id=bde84950"
import script from "./CardSidebarTabActivity.vue?vue&type=script&lang=js"
export * from "./CardSidebarTabActivity.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports